import { Link } from 'react-router-dom';
import { ButtonCommon } from 'components/common';
import { forbidden } from 'utils/importFile';
import { QuestionCircleFilled, ArrowRightOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

const Forbidden = () => {
  return (
    <div className='w-full min-h-screen flex flex-col bg-white'>
      <div className='flex-1 flex flex-col md:flex-row items-center justify-center px-4 md:px-12 py-12 gap-4'>
        <div className='max-w-4xl'>
          <h1 className='text-3xl md:text-[48px] md:leading-[46px] font-bold !mb-3 text-gray-800'>Xin lỗi bạn...</h1>

          <div className='space-y-2 font-bold text-[24px] leading-[32px] text-[var(--textGray)]'>
            <p>Bạn không có quyền truy cập vào trang này.</p>
            <p>Vui lòng liên hệ quản trị viên nếu bạn cần thêm quyền.</p>
            <p>Hoặc quay lại trang chủ để tiếp tục sử dụng hệ thống.</p>
          </div>

          <div className='mt-3.5'>
            <Link to='/' className='w-full'>
              <ButtonCommon
                size='md'
                color='basic'
                iconPosition='right'
                radius='rounded'
                icon={<ArrowRightOutlined />}
                className='py-2 hover:scale-105 transition-transform duration-200 origin-left'
              >
                <span className='flex items-center'>Quay Về Trang Chủ</span>
              </ButtonCommon>
            </Link>
          </div>
        </div>

        <div className='relative w-64 h-64 md:w-96 md:h-96'>
          <div className='absolute bottom-0 left-1/2 -translate-x-1/2 w-8/12 h-6 bg-[var(--textWhite)] rounded-[50%] blur-[14px] opacity-80'></div>
          <img src={forbidden} alt='Forbidden' className='w-full h-full object-contain' />
        </div>
      </div>

      <div className='flex items-center justify-start px-6 py-2 text-[var(--primaryColor)] font-semibold text-[16px]'>
        <span>Error 403</span>
        <Tooltip title='Bạn không có quyền truy cập' placement='top'>
          <QuestionCircleFilled className='ml-2 text-base text-[24px] hover:scale-110 transition-transform duration-200 cursor-help' />
        </Tooltip>
      </div>
    </div>
  );
};

export default Forbidden;
